import type { FaireProductEntity } from "../../entity_types/product";

export const p_89u6m6n344: FaireProductEntity = {
  token: "p_89u6m6n344",
  type: "product",
  name: "cowboy boot nashville shape candles",
  brandToken: "b_1jpuiv57",
  brandName: "gold + ivy",
  imageUrl:
    "https://cdn.faire.com/fastly/f89afd87c33690d9fa6536f6dfb19f3328167f812203bd62359ed8434f7a23bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6555caefb3c051c6d9b01d54dadd5fa5ba8b04272516ae5d4597f1c0c9e6f8e3.jpeg",
    "https://cdn.faire.com/fastly/c6cb18a1985bca323484559b593d774de036a47ac80e7faf81be8c865677a1a2.jpeg",
    "https://cdn.faire.com/fastly/fcc77f41063ec7e56919e5fd3c5c50df8f5f61344c9226a9bc4af600ec27125d.jpeg",
    "https://cdn.faire.com/fastly/6adb7dbaf4a138a264261017f17549966e0a35edf58a01887f19b7b0f15615db.jpeg",
    "https://cdn.faire.com/fastly/54ea5c3dfb034f1c92af3cd09231e8d3b780d395c2b3b7813e5e1e496c8342b4.jpeg",
    "https://cdn.faire.com/fastly/c29d637051b9b18a961056165cea2f9a3f7ad0939d504cd734d37ab4306bf2bd.jpeg",
    "https://cdn.faire.com/fastly/3a78e726929efe12add8b0b6d10f4ec370fca752ac1f9461dd80b2586209a9eb.jpeg",
    "https://cdn.faire.com/fastly/78d8baf2b84836614dd4a9a16307e21d3850080fcbdd0c2780ba0a679f65e113.jpeg",
    "https://cdn.faire.com/fastly/57414b78acd0d671a881e502423d1da9bd7d82a9d1ac07134f23d23242efd1fb.jpeg",
  ],
  priceDollars: 13,
  description:
    'Kick off your boots, sit back + let the comforting glow transport you to a place where time slows down and memories are made. Our Nashville cowboy boot shape candles are ideal for adorning your living space, unique gifting, or adding a touch of yeehaw to any special occasion.\n\nThese candles are scented with our signature "Nashville" fragrance, embodying notes of oakmoss, orange and amber. Choose from Bone, Desert, Sagebrush, Midnight or Dusty Rose hues.\n\napprox. 4 oz. | 4.5" x 3.75" x .75"\n\nBurn time approx. 1 hour.\n\ngold + ivy shape candles are made in Nashville, TN with 100% american-grown soy wax, cotton wicks, and eco color dyes. They contain no parabens, phthalates, or Prop 65 ingredients. Please note that each candle is hand poured using natural and nontoxic materials. This means that each candle may vary slightly in color, have minimal air bubbles, wax frosting, imperfect edges, and are a delicate item if dropped.\n\ndisco cowgirl, barbie pink, bachelorette, western, southern',
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:11.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
